import { PriceCell } from 'components/gifts-table/Cells';

export const columns = () => [
  {
    label: 'CONCEPTO',
    field: 'description',
    align: 'center',
    width: '50%',
  },
  {
    label: 'MONTO TRANSFERIDO',
    field: 'amount',
    align: 'center',
    renderer: (props) => (
      <PriceCell price={props.amount} align="center" width="10%" {...props} />
    ),
  },
  {
    label: 'FECHA',
    field: 'transaction_date',
    align: 'center',
    weight: 'bold',
    width: '20%',
  },
  {
    label: 'ESTATUS',
    field: 'transaction_status',
    align: 'center',
    textcolor: '#00c23d',
    width: '20%',
  },
];
